import React, { useState, useEffect, useCallback } from "react";
import mainBanner1 from "./assets/Roimages/banner-2.jpg";
import mainBanner2 from "./assets/Roimages/banner-3.png";
import mainBanner3 from "./assets/Roimages/banner-4.png";

export default function HomeSlider() {
  const images = [mainBanner1, mainBanner2, mainBanner3];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const goToNextImage = useCallback(() => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  }, [images.length]);

  const goToPreviousImage = useCallback(() => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentImageIndex(index);
  };

  useEffect(() => {
    const autoSlide = setInterval(goToNextImage, 5000);
    return () => clearInterval(autoSlide);
  }, [goToNextImage]);

  return (
    <div className="mainBanner">
      <div className="slider-container">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt="Bliss Water Technology"
            className={`slider-image ${index === currentImageIndex ? "active" : ""
              }`}
          />
        ))}
      </div>
      <div className="slider-controls">
        <button onClick={goToPreviousImage} className="prev-button" aria-label="Previous slide">
          &#10094;
        </button>
        <button onClick={goToNextImage} className="next-button" aria-label="Next slide">
          &#10095;
        </button>
      </div>
      <div className="slider-dots">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`slider-dot ${index === currentImageIndex ? "active" : ""}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

